/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';

import { TenantShareType } from '@api/types';

type TenantShareStoreStateType = {
  data: TenantShareType;
  initialized: boolean;
};

const initialState = (): TenantShareStoreStateType => ({
  data: {
    reviewEditTargetTables: [],
  },
  initialized: false,
});

export const useTenantShareStore = defineStore({
  id: 'tenantShare',
  state: initialState,
  actions: {
    $reset() {
      Object.assign(this, initialState());
    },
    set(data: TenantShareType): void {
      Object.keys(this.data).forEach((key) => {
        this.data[key] = data[key];
      });
      this.initialized = true;
    },
  },
});
